export default __webpack_public_path__ + "static/media/filter.affc62c5.svg";